/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MenuItem } from 'primeng/api/menuitem';
import { UserService } from '../../../core/services/user.service';
import { DivisionStation } from '../../shared/model/division-station.model';
import { YardLocalDetail } from '../../shared/model/yard-local-detail.model';
import { ConfigService } from './../../../core/services/config.service';
import { StationDetail } from './../../shared/model/station-detail.model';
import { YardLocalSubHeader } from './../../shared/model/yard-local-sub-header.model';


/**
 * @export
 * @class YardLocalSubHeaderComponent
 * @implements {OnInit}
 * @implements {OnChanges}
 */
@Component({
  selector: 'lms-yard-local-sub-header',
  templateUrl: './yard-local-sub-header.component.html',
  styleUrls: ['./yard-local-sub-header.component.scss']
})
export class YardLocalSubHeaderComponent implements OnInit, OnChanges {

  @Input() allStationDetailArr: Array<StationDetail>;
  @Input() stationDetailArr: Array<StationDetail>;
  @Output() allocStationTypeEvent = new EventEmitter();
  @Input() yardLocalSubHeader: YardLocalSubHeader;
  @Input() isAllocateButtonEnabled: boolean;
  @Input() isDeAllocateButtonEnabled: boolean;
  @Input() isPlanButtonEnabled: boolean;
  @Input() isStationIconSelected: boolean;
  @Input() yardLocalDetail: YardLocalDetail;
  @Output() loadYardLocalDataEvent = new EventEmitter<DivisionStation>();
  @Output() allocStationSearchYardLocalEvent = new EventEmitter<YardLocalSubHeader>();


  private COMMON_PICKLIST = 'commonopsPicklist';
  yardLocalOption: any;
  otherOptions: MenuItem[];
  configData: any;
  tabLevel: number;

  private ADD_ALLOCATION = 'addAllocationStation';
  private UPDATE_ALLOCATION = 'updateAllocationStation';
  private DELETE_ALLOCATION = 'deleteAllocationStation';

  private defaultSelectedOption = 'Y';
  isIncludeSpecialAllocation: boolean;
  commonopsPicklist: any;

  @Output() popupEventType = new EventEmitter();
  /**
   * Creates an instance of YardLocalSubHeaderComponent.
   * @memberof YardLocalSubHeaderComponent
   */
  constructor(private configService: ConfigService, public user: UserService) {
    this.configData = configService.getConfigData();
    this.tabLevel = this.configData.tabIndex.subTabs;
  }

  /**
   * Initialize the state of lifecycle hook.
   * @memberof YardLocalSubHeaderComponent
   */
  ngOnInit() {
    this.otherOptions = [];
    this.prepareOtherOptionsMenu();
    if (this.yardLocalDetail && this.yardLocalDetail.isLoaded) {
      if (this.yardLocalSubHeader) {
        this.yardLocalOption = this.yardLocalSubHeader.yardLocalOption;
        this.isIncludeSpecialAllocation = this.yardLocalSubHeader.isIncludeSpecialAllocation;
      } else {
        this.yardLocalOption = this.defaultSelectedOption;
      }
    } else if (this.yardLocalDetail && this.yardLocalDetail.yardLocalSubHeader) {
      this.yardLocalOption = this.yardLocalDetail.yardLocalSubHeader.yardLocalOption;
    } else {
      this.yardLocalOption = this.defaultSelectedOption;
    }
  }

  /**
   * Invoked when changes in lifecycle hook.
   * @memberof YardLocalSubHeaderComponent
   */
  ngOnChanges() {
    if (this.yardLocalDetail) {
      if (this.yardLocalSubHeader) {
        this.prepareOtherOptionsMenu();
        this.yardLocalOption = this.yardLocalSubHeader.yardLocalOption;
        this.isIncludeSpecialAllocation = this.yardLocalSubHeader.isIncludeSpecialAllocation;
      } else if (this.yardLocalDetail && this.yardLocalDetail.yardLocalSubHeader) {
        this.yardLocalOption = this.yardLocalDetail.yardLocalSubHeader.yardLocalOption;
      } else {
        this.yardLocalOption = this.defaultSelectedOption;
      }
    }
  }


  /**
   * Preprae other action in sub header component.
   * @memberof YardLocalSubHeaderComponent
   */
  prepareOtherOptionsMenu() {
    this.otherOptions = [
      {
        label: this.configData.yardLocalLabel.addAllocationStation, command: () => {
          event.stopPropagation();
          this.popupEventType.emit(this.ADD_ALLOCATION);
        }, disabled: this.user && !this.user.isUserManagerOrDirector
      },
      {
        label: this.configData.yardLocalLabel.updateAllocationStation, command: () => {
          event.stopPropagation();
          this.popupEventType.emit(this.UPDATE_ALLOCATION);
        }, disabled: !this.isStationIconSelected || this.user && this.user.isUserManagerOrDirector
      },
      {
        label: this.configData.yardLocalLabel.deleteAllocationStation, command: () => {
          event.stopPropagation();
          this.popupEventType.emit(this.DELETE_ALLOCATION);
        }, disabled: !this.isStationIconSelected || this.user && this.user.isUserManagerOrDirector
      }];
  }

  /**
   * Invoked when changes in filter radio options.
   * @memberof YardLocalSubHeaderComponent
   */
  updateYardLocalOption() {
    if (this.yardLocalOption === 'S') {
      this.isIncludeSpecialAllocation = false;
    }
    if (this.yardLocalSubHeader) {
      this.yardLocalSubHeader.yardLocalOption = this.yardLocalOption;
      this.yardLocalSubHeader.isIncludeSpecialAllocation = this.isIncludeSpecialAllocation;
    } else {
      this.yardLocalSubHeader = {
        yardLocalOption: this.yardLocalOption,
        isIncludeSpecialAllocation: this.isIncludeSpecialAllocation
      };
    }
    this.allocStationTypeEvent.emit(this.yardLocalSubHeader);
  }

  /**
   * searh yard and local
   * @memberof YardLocalSubHeaderComponent
   */
  searchYardLocal() {
    this.updateYardLocalOption();
    this.allocStationSearchYardLocalEvent.emit(this.yardLocalSubHeader);

  }
  /**
   * Invoked when click on checkbox of include special allocation.
   * @memberof YardLocalSubHeaderComponent
   */
  updateIncludeSpecAlloc() {
    if (this.yardLocalOption && this.yardLocalOption !== 'S') {
      if (this.yardLocalSubHeader) {
        this.yardLocalSubHeader.yardLocalOption = this.yardLocalOption;
        this.yardLocalSubHeader.isIncludeSpecialAllocation = this.isIncludeSpecialAllocation;
      } else {
        this.yardLocalSubHeader = {
          yardLocalOption: this.yardLocalOption,
          isIncludeSpecialAllocation: this.isIncludeSpecialAllocation
        };
      }
      this.allocStationTypeEvent.emit(this.yardLocalSubHeader);
    }
  }
}
